import React from "react";
import styles from "./RowWrapper.module.scss";

export function RowWrapper({ children }) {
  return <div className={styles.rowWrapper}>{children}</div>;
}
